import { Directive, ElementRef } from '@angular/core'

@Directive({
  selector: '[subMainContent]',
  host: {
    '(window:resize)': 'onResize($event)'
  }
})

export class SubMainContentDirective {
  constructor(private elRef: ElementRef) {}

  ngAfterViewChecked() {
    this.adjustPosition()
  }

  private onResize(event) {
    this.adjustPosition()
  }

  private adjustPosition() {
    let headerEl = document.querySelector('[subMainHeader]')
    let footerEl = document.querySelector('[subMainFooter]')
    let marginTop = headerEl ? headerEl.clientHeight : 0
    let marginBottom = footerEl ? footerEl.clientHeight : 0
    this.elRef.nativeElement.style.marginTop = `${marginTop}px`
    this.elRef.nativeElement.style.marginBottom = `${marginBottom}px`
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/directives/sub-main-content.directive.ts